import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {SerializableOrderLine} from "../api";

export class NonSerializedOrderLineService extends RestService<SerializableOrderLine> {
    constructor(url) {
        if (url) {
            super(url)
        } else {
            super(REST_API_END_POINTS.SERIALIZABLE_ORDER_LINE)
        }
    }
}

export const SerializableOrderLineService = NonSerializedOrderLineService
